import React from 'react'
import { Modal } from './ui/Modal'
import { Button } from './ui/Button'
import { JVPoint } from '../data/types'
import { POINT_FIELDS, DUTY_LISTS, computeTotalPoints } from './AddJVPointModal'

type Props = {
    isOpen: boolean
    onClose: () => void
    entry: JVPoint
}

export const ViewJVPointModal = ({ isOpen, onClose, entry }: Props) => {
    const footer = (
        <Button variant="outline" onClick={onClose}>Close</Button>
    )

    return (
        <Modal isOpen={isOpen} onClose={onClose} title="Point Record Details" footer={footer} maxWidth="2xl">
            <div className="px-6 py-4 space-y-6">
                <div>
                    <p className="text-sm font-medium text-gray-700 dark:text-gray-300">Date of Entry</p>
                    <p className="text-gray-900 dark:text-gray-100">{entry.date_of_entry}</p>
                </div>

                <div>
                    <p className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Total Points</p>
                    <p className="text-2xl font-bold text-gray-900 dark:text-gray-100">{computeTotalPoints(entry)}</p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    {POINT_FIELDS.map(({ key, label }) => (
                        <div key={key} className="flex items-center justify-between py-2 px-3 bg-gray-50 dark:bg-gray-900 rounded-md">
                            <span className="text-sm text-gray-700 dark:text-gray-300">{label}</span>
                            <span className="text-sm font-medium text-gray-900 dark:text-gray-100">
                                {(entry[key as keyof JVPoint] as number | null | undefined) ?? 0}
                            </span>
                        </div>
                    ))}
                </div>

                {DUTY_LISTS.map(({ key, label }) => {
                    const items = (entry[key] ?? []) as { name: string; points: number }[]
                    return (
                        <div key={key}>
                            <p className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">{label}</p>
                            {items.length === 0 ? (
                                <p className="text-sm text-gray-500 dark:text-gray-400">No entries</p>
                            ) : (
                                <div className="flex flex-col gap-2">
                                    {items.map((item, index) => (
                                        <div
                                            key={index}
                                            className="flex items-center justify-between py-2 px-3 bg-gray-50 dark:bg-gray-900 rounded-md"
                                        >
                                            <span className="text-sm text-gray-700 dark:text-gray-300">{item.name}</span>
                                            <span className="text-sm font-medium text-gray-900 dark:text-gray-100">{item.points} pts</span>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    )
                })}
            </div>
        </Modal>
    )
}
